import i18nFactory from '@yandex-int/i18n';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';

import { Action } from '../../actions/index';
import {
    ADD_REPORT,
    FETCH_REPORTS,
    fetchReports,
    showReportsGeneralError,
    stopReportsLoading,
    updateReports
} from '../../actions/reportsClient';
import { mapReportsApiDataToClientData, mapReportsDatesToApiFormat } from '../../mappers/reports/reports';
import { ApiMethodExecutingError } from '../../service/Errors';
import { showNoticeMessage } from '../../service/GridHelpers/GridHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { getReportsSuccessTexts } from '../../service/TextStoreHelpers/TextStoreHelpers';
import { NoticeType } from '../../typings/grid';
import { State } from '../../typings/state';

import * as keyset from './reportsClient.i18n';

const i18n = i18nFactory(keyset);

const fetchReportsDataEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(FETCH_REPORTS).mergeMap(
        (): Observable<Action> => {
            const {
                reportClient: { login }
            } = store$.value;

            return Observable.fromPromise(deps.restApiManager.fetchReports(login))
                .map(data => {
                    const reports = mapReportsApiDataToClientData(data.result || []);

                    return updateReports(reports);
                })
                .catch((err: ApiMethodExecutingError) => {
                    return Observable.of(showReportsGeneralError(err));
                });
        }
    );
};

const addReportEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(ADD_REPORT).mergeMap(
        (): Observable<Action> => {
            const {
                reportClient: { periodValue, login }
            } = store$.value;
            const dates = mapReportsDatesToApiFormat(periodValue);
            const response$ = Observable.fromPromise(deps.restApiManager.addReport(login, dates));

            return response$
                .do((response: { success?: boolean }) => {
                    const success = response.success;
                    if (success) {
                        showNoticeMessage(NoticeType.success, getReportsSuccessTexts('addReport'));
                    }
                })
                .map(() => fetchReports(login))
                .catch((error: ApiMethodExecutingError) => {
                    const errorMessage = error.getMessage();
                    const errorText = typeof error === 'string' ? errorMessage : i18n('request-error');
                    showNoticeMessage(NoticeType.error, errorText);
                    return Observable.of(stopReportsLoading);
                });
        }
    );
};

export { fetchReportsDataEpic, addReportEpic };
